import axios from 'axios'
import { REACT_APP_PERITADOR_API } from '../../config'

export async function setPeritajeStatusRemovedCars(body) {
    const peritajeStatus = await axios.patch(
        `${REACT_APP_PERITADOR_API}/requests/presupuesto_reservado`,
    body
    )

    return peritajeStatus
}
